import clsx from "clsx";
import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import { useEditorInterface } from "../App";
import { Island } from "../Island";
import Stack from "../Stack";
import { DropdownMenuContentPropsContext } from "./common";

const MenuContent = ({
  children,
  onClickOutside,
  className = "",
  onSelect,
  style,
  placement = "bottom",
}: {
  children?: React.ReactNode;
  onClickOutside?: () => void;
  className?: string;
  onSelect?: (event: Event) => void;
  style?: React.CSSProperties;
  placement?: "top" | "bottom";
}) => {
  const editorInterface = useEditorInterface();
  const classNames = clsx(`dropdown-menu ${className}`, {
    "dropdown-menu--mobile": editorInterface.formFactor === "phone",
    "dropdown-menu--placement-top": placement === "top",
  }).trim();

  return (
    <DropdownMenuContentPropsContext.Provider value={{ onSelect }}>
      <DropdownMenuPrimitive.Portal>
        <DropdownMenuPrimitive.Content
          className={classNames}
          style={style}
          data-testid="dropdown-menu"
          side={placement}
          sideOffset={4}
          onCloseAutoFocus={(e) => {
            onClickOutside?.();
          }}
          onPointerDownOutside={() => {
            onClickOutside?.();
          }}
          onEscapeKeyDown={() => {
            onClickOutside?.();
          }}
        >
          {editorInterface.formFactor === "phone" ? (
            <Stack.Col className="dropdown-menu-container">{children}</Stack.Col>
          ) : (
            <Island
              className="dropdown-menu-container"
              padding={2}
              style={{ zIndex: 2 }}
            >
              {children}
            </Island>
          )}
        </DropdownMenuPrimitive.Content>
      </DropdownMenuPrimitive.Portal>
    </DropdownMenuContentPropsContext.Provider>
  );
};
MenuContent.displayName = "DropdownMenuContent";

export default MenuContent;
